module.exports = __webpack_public_path__ + "img/bg-6.62dab330.jpg";